import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Magacin } from './magacin';
// import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-magacin-update',
  templateUrl: './magacin-update.component.html'
})
export class MagacinUpdateComponent extends BaseUpdateComponent<Magacin> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'MAGACIN.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(100), 'maxlength', 'MAGACIN.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("SNaziv", Validators.required, 'required', 'MAGACIN.SNAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("SNaziv", Validators.maxLength(5), 'maxlength', 'MAGACIN.SNAZIV.VALIDATION.MAXLENGTH');
  }

}
